import { render } from "./ViewProjectsModal.vue?vue&type=template&id=4746c699"
import script from "./ViewProjectsModal.vue?vue&type=script&lang=js"
export * from "./ViewProjectsModal.vue?vue&type=script&lang=js"

import "./ViewProjectsModal.vue?vue&type=style&index=0&id=4746c699&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__